import { api_GET, api_POST, api_PUT } from './_api';

const modalidadeColeta_api = {
    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`ModalidadeColeta/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetListAtivos: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`ModalidadeColeta/GetListAtivos`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetModalidadesPorTransportador: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`ModalidadeColeta/GetModalidadesPorTransportador`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`ModalidadeColeta/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`ModalidadeColeta`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`ModalidadeColeta`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}
export default modalidadeColeta_api;